export default [
  { id: "#path5419", d: "M169.8,626.6l-25.6-46.1l-35.3,32.7L169.8,626.6z" },
  { id: "#path4232", d: "M528.9,461.7l-56.3-15.5l25.6-12.4L528.9,461.7z" },
  { id: "#path4236", d: "M276.3,371.4l20.9,21.7l9.3-55.2L276.3,371.4z" },
  { id: "#path4240", d: "M315.8,263l-12.6-71l49.9,71H315.8z" },
  { id: "#path4244", d: "M91.4,558.9L50,523l53,85.4L91.4,558.9z" },
  { id: "#path4248", d: "M365.9,405.6l36.4,22.4l-29.1,18.3L365.9,405.6z" },
  { id: "#path4252", d: "M353,437.9l13-32.3l-62.6,19.1L353,437.9z" },
  { id: "#path4628", d: "M373.2,345.2l-32.8-20.9l-6,45.7L373.2,345.2z" },
  { id: "#path4632", d: "M110.2,498l-51-38.4l73.3,1.5L110.2,498z" },
  { id: "#path4634", d: "M293.5,343.1l-19.7-16.8l-11.1,29.4L293.5,343.1z" },
  { id: "#path4636", d: "M486.2,328.8l3.3-10.1l27,3.3L486.2,328.8z" },
  { id: "#path4644", d: "M173.4,515.5l4.8,23.6l26.1-27.9L173.4,515.5z" },
  { id: "#path4646", d: "M302.5,290.4l43.2,9.3l-55.2,26.1L302.5,290.4z" },
  { id: "#path4648", d: "M173.4,515.5l-21.4,51.8l-57.1-11.5L173.4,515.5z" },
  { id: "#path4656", d: "M186.6,500.4l-13.1,15l51.6-38L186.6,500.4z" },
  { id: "#path4658", d: "M187.4,474.6L164,491.3l-45.8,4.5L187.4,474.6z" },
  { id: "#path4660", d: "M194.2,496.2l-38.8,22.2l8.6-27.3L194.2,496.2z" },
  { id: "#path4662", d: "M580.1,488.3l-52.7,20.4l25.8-34.4L580.1,488.3z" },
  { id: "#path4672", d: "M165.6,560.8l38.8-36l-7.8,46.3L165.6,560.8z" },
  { id: "#path4674", d: "M594.9,508.7l20.3-20.8l-56.7,19.2L594.9,508.7z" },
  { id: "#path4676", d: "M478.9,493.8l47.5,9.4l-94.9,21.1L478.9,493.8z" },
  { id: "#path4678", d: "M493.9,510.5l32.4,25.2l-94.9-11.3L493.9,510.5z" },
  { id: "#path4688", d: "M498.3,433.7l-19.2,60.1l-11.5-88.3L498.3,433.7z" },
  { id: "#path4690", d: "M431.6,524.2l47.5-30.5l-27.1-35.9L431.6,524.2z" },
  { id: "#path4692", d: "M373.2,483.8l58.3,40.4l-7.3-76.1L373.2,483.8z" },
  { id: "#path4694", d: "M214.7,278l33.5,13.8l-9.3-38.5L214.7,278z" },
  { id: "#path4704", d: "M373.2,483.8l35.9,24.9l17.6-34.3L373.2,483.8z" },
  { id: "#path4706", d: "M248.1,291.6l45.5,2l-3.3-30.6L248.1,291.6z" },
  { id: "#path4708", d: "M235.7,251.8l40.6-32.3l-47.5-5.2L235.7,251.8z" },
  { id: "#path4729", d: "M91.4,483.8l-37.3,7.8l5.2-32L91.4,483.8z" },
  { id: "#path4731", d: "M293.5,176l-3.3,87l32.3-43.6L293.5,176z" },
  { id: "#path4733", d: "M293.5,176l-96.4,57.1l62.2,29.8L293.5,176z" },
  { id: "#path4735", d: "M340.3,324.3l12.6-61.3l35,35.7L340.3,324.3z" },
  { id: "#path4743", d: "M353,263l-59.6-87l-34.2,87H353L353,263z" },
  { id: "#path4747", d: "M108.9,613.2l60.8,13.2l-4.2-65.8L108.9,613.2z" },
  { id: "#path4749", d: "M456.2,423.5l-24.6,100.8l-58.4-40.4L456.2,423.5z" },
  { id: "#path4755", d: "M297,393.2l-34.4-37.6l77.8-31.4L297,393.2z" },
  { id: "#path4757", d: "M343.4,464.9l20.7,33.8l5.6-50.2L343.4,464.9z" },
  { id: "#path4776", d: "M456.2,423.5l-40.2-4.1l32.4-31.8L456.2,423.5z" },
  { id: "#path4778", d: "M456.2,423.5l-7.7-35.9l27.5,3L456.2,423.5z" },
  { id: "#path4780", d: "M377.3,375.7l38.7,43.7l8.2-61L377.3,375.7z" },
  { id: "#path4799", d: "M230.6,500.4l8.2,11.8l-69.1,114.3L230.6,500.4z" },
  { id: "#path4801", d: "M108.9,613.2L225,489L94.7,555.7L108.9,613.2z" },
  { id: "#path4818", d: "M108.9,613.2l115-123l6.5,10.2L108.9,613.2z" },
  { id: "#path4820", d: "M580.1,488.3l-53.6,47.1L650,487.3L580.1,488.3z" },
  { id: "#path4822", d: "M108.9,503.3l46.2,15l-60.4,37.5L108.9,503.3z" },
  { id: "#path4824", d: "M467.4,405.6l-35.9,118.8l97.4-62.5L467.4,405.6z" },
  { id: "#path4858", d: "M373.2,483.8l42.8-64.5l-72.6,45.5L373.2,483.8z" },
  { id: "#path4860", d: "M286.2,498l-23.6-26.3l32.4,17.2L286.2,498z" },
  { id: "#path4862", d: "M303.3,424.5l-26.1,41.7l5.2,5.4L303.3,424.5z" },
  { id: "#path4864", d: "M156.7,483.8l-24.1-22.8l49.8,1.1L156.7,483.8z" },
  { id: "#path4866", d: "M282.3,471.7l28.6-33.9l11.5,20.1L282.3,471.7z" },
  { id: "#path4878", d: "M50.1,516.4l58.9-13.1l-14,52.6L50.1,516.4z" },
  { id: "#path4880", d: "M320.9,518.3l43.2-19.6l2.8-24.8L320.9,518.3z" },
  { id: "#path4961", d: "M580.1,488.3L529,461.7l-2.5,73.9L580.1,488.3z" },
  {
    id: "#path5128",
    d: "M225.2,488.9L94.9,555.6l130.3-78.2L225.2,488.9L225.2,488.9z"
  },
  { id: "#path5130", d: "M431.6,524.2l94.9,11.3l2.5-73.9L431.6,524.2z" },
  { id: "#path5136", d: "M293.5,176h-67.9l14,32L293.5,176z" },
  { id: "#path5138", d: "M110.2,498l22.4-36.9l-73.3-1.5L110.2,498z" },
  { id: "#path5140", d: "M424.3,358.5l-34.8-22.9l-12.2,40.1L424.3,358.5z" },
  { id: "#path5142", d: "M293.5,176l-59.3,151.3l119-64.3L293.5,176z" },
  { id: "#path5144", d: "M171.1,626.6l59.3-126.2L108.8,613.2L171.1,626.6z" },
  { id: "#path5166", d: "M225.2,477.5L94.9,555.7L50,516.4L225.2,477.5z" },
  { id: "#path5168", d: "M243.4,73.4l37.2,32.6l-26.7,12.8L243.4,73.4z" },
  { id: "#path5170", d: "M511.1,360.9L476,390.8l10.3-38.5L511.1,360.9z" },
  { id: "#path5172", d: "M448.5,387.7l27.5,3l10.3-38.5L448.5,387.7z" },
  { id: "#path5174", d: "M230.6,500.4l-6.5-10.2l38.5-18.5L230.6,500.4z" },
  { id: "#path5176", d: "M479.3,314l-8.9,26.6l71.4-21.8L479.3,314z" },
  { id: "#path5186", d: "M222,463.9l3.2,13.5l-175,39.1L222,463.9z" },
  { id: "#path5188", d: "M225.2,463.1l-166-3.3L50,516.5L225.2,463.1z" },
  { id: "#path5190", d: "M486.4,352.1l-16-11.5l71.4-21.8L486.4,352.1z" },
  { id: "#path5200", d: "M551.5,322.2l-65.1,29.9l55.3-33.4L551.5,322.2z" },
  { id: "#path5202", d: "M486.4,352.1l24.8,8.6l40.4-38.7L486.4,352.1z" },
  { id: "#path5204", d: "M486.4,352.1l-16-11.5l-4.8,12.2L486.4,352.1z" },
  { id: "#path5206", d: "M197.1,233.4L254,119l39.5,57.1L197.1,233.4z" },
  { id: "#path5208", d: "M470.5,340.7l-46.1,17.7l24.2,29.3L470.5,340.7z" },
  { id: "#path5258", d: "M429.2,318.9l-4.9,39.6l54.9-44.4L429.2,318.9z" },
  { id: "#path5260", d: "M470.5,340.7l-46.1,17.7l54.9-44.4L470.5,340.7z" },
  { id: "#path5262", d: "M234,327.4l-36.9-94.1l96.4-57.1L234,327.4z" },
  { id: "#path5270", d: "M410.9,322.2l-176.7,5.3l63,65.9L410.9,322.2z" },
  { id: "#path5272", d: "M353,263l-119,64.3l176.7-5.3L353,263z" },
  { id: "#path5286", d: "M280.6,106l12.7,70L253.9,119L280.6,106z" },
  { id: "#path5288", d: "M303.3,424.5l74-48.9l-80.4,17.5L303.3,424.5z" },
  { id: "#path5296", d: "M282.3,471.7l61.2-6.8l-48.5,24L282.3,471.7z" },
  { id: "#path5298", d: "M377.3,375.7l-74,48.9l40.1,40.4L377.3,375.7z" },
  { id: "#path5306", d: "M230.6,500.4l8.2,11.8l23.6-40.5L230.6,500.4z" },
  { id: "#path5310", d: "M286.2,498l-47.3,14.3l23.6-40.5L286.2,498z" },
  { id: "#path5316", d: "M262.6,471.7l4.8-42l-42.1,47.8L262.6,471.7z" },
  { id: "#path5324", d: "M410.9,322.2l16.3,13.4h-37.6L410.9,322.2z" },
  { id: "#path5341", d: "M410.9,322.2l18.3-3.3l-2,16.7L410.9,322.2z" },
  { id: "#path5343", d: "M322.5,458l-19.1-33.5l31-20.5L322.5,458z" },
  { id: "#path5345", d: "M277.2,466.2l-9.9-36.5l29.8-36.5L277.2,466.2z" },
  { id: "#path5357", d: "M222,463.9l45.3-34.3l-42.1,47.8L222,463.9z" },
  { id: "#path5359", d: "M262.6,471.7h19.7l-5.2-5.4L262.6,471.7z" },
  { id: "#path5361", d: "M349.1,491l-5.6-24.8l-48.5,22.6L349.1,491z" }
];
